import React from 'react'
import { FilterDropdown } from './FilterDropdown'
import { Popover } from 'react-tiny-popover'
import { useIsTablet } from '../useIsTablet'
import classNames from 'classnames'

export function FilterItem({
  label,
  optionsCount,
  value,
  onChange,
  isPopoverOpen,
  setIsPopoverOpen,
  productCount,
  whiteBackground = false,
  isModels
}) {
  const ref = React.useRef(null)

  if (useIsTablet()) {
    return (
      <div className='mtt-filter__item' onClick={() => setIsPopoverOpen(!isPopoverOpen)} ref={ref}>
        <span>{label}</span>
        {isPopoverOpen ? (
          <FilterDropdown
            optionsCount={optionsCount}
            value={value}
            onChange={onChange}
            productCount={productCount}
            onViewProductsClick={() => setIsPopoverOpen(false)}
            isModels={isModels}
          />
        ) : null}
      </div>
    )
  }
  return (
    <Popover
      isOpen={isPopoverOpen}
      positions={['bottom', 'right', 'top', 'left']}
      align='start'
      padding={10}
      onClickOutside={(e) => {
        setIsPopoverOpen(false)
      }}
      content={
        <FilterDropdown
          optionsCount={optionsCount}
          value={value}
          onChange={onChange}
          productCount={productCount}
          onViewProductsClick={() => setIsPopoverOpen(false)}
          whiteBackground={whiteBackground}
          isModels={isModels}
        />
      }
    >
      <div
        className={classNames('mtt-filter__item', { active: isPopoverOpen, white: whiteBackground })}
        onClick={() => setIsPopoverOpen(!isPopoverOpen)}
        ref={ref}
      >
        <span>{label}</span>
      </div>
    </Popover>
  )
}
